import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { FilterBox } from '../../../../ui'
import { INSTALLERS_FILTERS } from '../../constants'

export const PrescriptorInstallersFilter = () => {
  const { formatMessage } = useIntl()
  const userEmpresasCa = useSelector((state) => state.global.empresa_cc_aa)

  const filteredCAs = useMemo(
    () =>
      userEmpresasCa?.map((ca) => ({
        key: ca.id_empresa || ca.id,
        value: ca.nombre_cc_aa,
      })) || [],
    [userEmpresasCa]
  )

  const comboValues = useMemo(
    () => ({
      user_empresas_ca: filteredCAs,
    }),
    [filteredCAs]
  )

  const filters = INSTALLERS_FILTERS.map((item) => {
    return {
      ...item,
      label: formatMessage({
        id: item.label,
      }),
      values: item.comboId ? comboValues[item.comboId] || [] : undefined,
    }
  })

  return <FilterBox filters={filters} />
}
